import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import ConstantForm from '../../../common/ConstantForm';
import { snakeCaseToTitleCase } from '../../../../common/utils/api_utils';
import CustomLoader from '../../../common/CustomLoader';
import showAlert from '../../../../common/utils/alert';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import { description } from '../../../../common/utils/event_constants';

export default class ConstantDetail extends Component {
  static propTypes = {
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    showConstantValue: PropTypes.func.isRequired,
    constant: PropTypes.object.isRequired,
  };

  state = {
    isEditConstant: false,
  };

  enableUpdateConstant = () => {
    this.setState({ isEditConstant: true });
  };

  disableUpdateConstant = () => {
    this.setState({ isEditConstant: false });
  };

  updateConstant = (updatedConstantObj) => {
    const { projectId, collection, constant, version } = this.props;
    updatedConstantObj.uuid = constant.uuid;
    const finalConstantObj = {
      projectId,
      collectionUuid: collection.uuid,
      constantUuid: constant.uuid,
      data: updatedConstantObj,
      version,
    };
    this.props.actions.updateConstantOfCollection(finalConstantObj);
    this.disableUpdateConstant();
  };

  handleDelete = () => {
    const { projectId, collection, constant, version } = this.props;
    const preConfirm = () => {
      this.props.actions.deleteCollectionConstant({
        projectId,
        version,
        collectionUuid: collection.uuid,
        constantId: constant.uuid,
      });
    };
    showAlert("You won't be able to revert this.", preConfirm, 'Yes, delete it!');
  };

  showEditConstant = () => {
    const {
      constant,
      showConstantValue,
      showDerivedConstantLoader,
      showConstantDeleteLoader,
      deleteFlag,
    } = this.props;
    const { isEditConstant } = this.state;

    if (isEditConstant) {
      return (
        <div className="col-12">
          <ConstantForm
            constantType={constant.constantType}
            constant={constant}
            handleSubmit={this.updateConstant}
            showDerivedConstantLoader={showDerivedConstantLoader}
            isCollection={true}
          />
        </div>
      );
    } else {
      return (
        <Fragment>
          <div className="col-12">
            <div className="pt-1">
              <b>Name: </b> {constant.name}
            </div>

            <div className="pt-1">
              <b>Type: </b> {snakeCaseToTitleCase(constant.constantType)}
            </div>

            <div className="pt-1 word-overflow">
              <b>Value: </b> {showConstantValue(constant.constantType, constant.value)}
            </div>
          </div>
          <div className="col-12 text-right pb-2">
            <button
              type="button"
              className="btn btn-sm btn-theme-delete mr-1"
              disabled={showConstantDeleteLoader}
              style={{ cursor: deleteFlag ? 'pointer' : 'not-allowed' }}
              onClick={deleteFlag ? this.handleDelete : undefined}
            >
              <i className="wb webconnect-trash-regular"></i> Delete&nbsp;
              {deleteFlag ? null : (
                <TooltipInfo
                  title={description}
                  headerText={`Permission Disabled!`}
                  showHeader={true}
                  showArrow={true}
                />
              )}
              <CustomLoader loading={showConstantDeleteLoader} />
            </button>
            <button
              type="button"
              className="btn btn-sm btn-theme-submit mr-1"
              disabled={showDerivedConstantLoader}
              onClick={this.enableUpdateConstant}
            >
              <i className="wb webconnect-pencil"></i> Edit
            </button>
          </div>
        </Fragment>
      );
    }
  };

  render() {
    return <div className="row pt-2">{this.showEditConstant()}</div>;
  }
}
